var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "calendar-field-title" }, [
    _c("h6", [_vm._t("default")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "border-bottom" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }